import { render, staticRenderFns } from "./ProgressBadgeModal.vue?vue&type=template&id=5cdc20d4&scoped=true"
import script from "./ProgressBadgeModal.vue?vue&type=script&lang=ts"
export * from "./ProgressBadgeModal.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBadgeModal.vue?vue&type=style&index=0&id=5cdc20d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdc20d4",
  null
  
)

export default component.exports